import OrderReview from '@/components/Order/OrderReview/OrderReview'

const page = () => {
  return <OrderReview />
}

export default page
